function objectFit() {
    const pictureTags = document.querySelectorAll('.responsive-image');
    const responsiveImages = Array.from(pictureTags);
    responsiveImages.forEach((element) => {

        const wrapper = document.createElement('div');
        wrapper.classList.add('responsive-image__wrapper');
        const originalImage = element.querySelector('.responsive-image__img');

        if (originalImage.classList.contains('responsive-image__img--fallback')) {
            originalImage.parentNode.parentNode.style.backgroundImage = `url(${originalImage.src})`;
        } else {
            originalImage.classList.add('responsive-image__img--fallback');
            wrapper.style.backgroundImage = `url(${originalImage.src})`;
            element.parentNode.insertBefore(wrapper, element);
            wrapper.appendChild(element);
        }
    });
}

function isIe() {
    // Check for IE only!
    if ((/*@cc_on!@*/false) || (document.documentMode)) {
        return true;
    }
}

export default function init() {
    if (isIe()) {
        objectFit();
    }
}

